import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LatestService } from 'src/app/_models/latestService.model';
import { MobileRoutes } from 'src/app/_models/routes.model';
import { LatestServicesService } from 'src/app/_services/latest-services.service';
import { RoutesService } from 'src/app/_services/routes.service';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { baseUrl, environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxImageCompressService } from 'ngx-image-compress';

@Component({
  selector: 'app-add-latest-service',
  templateUrl: './add-latest-service.component.html',
  styleUrls: ['./add-latest-service.component.scss'],
})
export class AddLatestServiceComponent implements OnInit {
  pageTitle: string = 'Latest Services';
  routes: MobileRoutes[];
  ranks = Array(50);
  imageFile;
  editMode = false;
  latestService: LatestService = {};
  addServiceForm: FormGroup;
  isSubmited: boolean = false;
  serviceFileName: string = '';

  constructor(
    private latestServiceService: LatestServicesService,
    private routesService: RoutesService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router,
    private _formBuilder: FormBuilder,
    private imageCompress: NgxImageCompressService
  ) {}

  ngOnInit(): void {
    this.addServiceForm = this._formBuilder.group({
      enServiceName: [
        null,
        [Validators.required, Validators.pattern(/^[A-Za-z][A-Za-z0-9 .-]*$/)],
      ],
      arServiceName: [
        null,
        [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 .-]+$/)],
      ],
      enServiceShortDescription: [
        null,
        [Validators.required, Validators.pattern(/^[A-Za-z][A-Za-z0-9 .-]*$/)],
      ],
      arServiceShortDescription: [
        null,
        [Validators.required, Validators.pattern(/^[\u0621-\u064A0-9 .-]+$/)],
      ],
      serviceType: [false, [Validators.required]],
      serviceStatus: [false, [Validators.required]],
      serviceRoute: [null, [Validators.required]],
      serviceRank: [null, [Validators.required]],
      serviceFileInput: [null, [Validators.required]],
    });

    this.editMode =
      this.activatedRoute.snapshot.url[1] &&
      this.activatedRoute.snapshot.url[1].path === 'edit' &&
      true;

    this.getAllRoutes();

    if (this.editMode) {
      const id = this.activatedRoute.snapshot.params.serviceId;
      this.getServiceById(id);
    }
  }

  getAllRoutes() {
    this.routesService.getAllRoutes().subscribe((res) => {
      this.routes = res.data?.routes;
    });
  }

  getServiceById(serviceId) {
    this.latestServiceService.getServiceById(serviceId).subscribe((res) => {
      this.latestService = res.data;

      this.serviceFileName = this.latestService['picture'].split('/').pop();

      this.addServiceForm.patchValue({
        enServiceName: this.latestService.enName,
        arServiceName: this.latestService.arName,
        enServiceShortDescription: this.latestService.enShortDescription,
        arServiceShortDescription: this.latestService.arShortDescription,
        serviceType:
          this.latestService.typeId == 1
            ? true
            : this.latestService.typeId == 2
            ? false
            : this.latestService.typeId,
        serviceStatus:
          this.latestService.statusId == 1
            ? true
            : this.latestService.statusId == 2
            ? false
            : this.latestService.statusId,
        serviceRoute: this.latestService.routeId,
        serviceRank: this.latestService.rank,
        serviceFileInput: this.serviceFileName,
      });

      document.getElementById(
        'placeholder'
      ).style.backgroundImage = `url(${this.latestService['picture']})`;
    });
  }

  routeChanged(value): void {
    const route = this.routes.find((r) => r.id === +value);

    if (route) {
      this.latestService.routeId = route.id;
      this.latestService.routeName = route.routeName;
    }
  }

  onAddServiceSubmit() {
    this.isSubmited = true;

    let serviceTypeId = this.addServiceForm.value.serviceType ? 1 : 2;
    let serviceStatusId = this.addServiceForm.value.serviceStatus ? 1 : 2;

    this.latestService.enName = this.addServiceForm.value.enServiceName;
    this.latestService.arName = this.addServiceForm.value.arServiceName;
    this.latestService.enShortDescription =
      this.addServiceForm.value.enServiceShortDescription;
    this.latestService.arShortDescription =
      this.addServiceForm.value.arServiceShortDescription;
    this.latestService.typeId = serviceTypeId;
    this.latestService.statusId = serviceStatusId;
    this.latestService.routeId = this.addServiceForm.value.serviceRoute;
    this.latestService.rank = this.addServiceForm.value.serviceRank;

    if (this.addServiceForm.valid) {
      if (this.editMode) {
        this.latestServiceService
          .updateService(this.imageFile, this.latestService)
          .subscribe((res) => {
            showNotification(
              'success',
              `${res.data.enName} has been updated`,
              this.toastr
            );
            this.router.navigateByUrl('services');
          });
      } else {
        this.latestServiceService
          .addNewService(this.imageFile, this.latestService)
          .subscribe((res) => {
            showNotification(
              'success',
              `${res.data.enName} has been added`,
              this.toastr
            );
            this.router.navigateByUrl('services');
          });
      }
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }

  onImageUpload(event): void {
    event.preventDefault();

    this.imageCompress.uploadFile().then(({ image, orientation }) => {
      this.imageCompress
        .compressFile(image, orientation, 15, 20)
        .then((result: any) => {
          this.imageFile = this.dataURLtoFile(result, 'filename.png');
          const split = result.split(',');
          const type = split[0].replace('data:', '').replace(';base64', '');

          document.getElementById(
            'placeholder'
          ).style.backgroundImage = `url(${result})`;

          this.addServiceForm.controls['serviceFileInput'].setValue(
            event ? 'image.png' : ''
          );
        });
    });
  }

  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }
}
